










import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import ChangeEmailMixin from '@/mixins/change-email.mixin';
import AuthenticationModule from '@/store/modules/authentication.module';
import store from '@/store';
import { getModule } from 'vuex-module-decorators';
import { routeName, routePath } from '@/constants/route.constants';
import LoadingComponent from '@/components/shared/loading.component.vue';
import { mapState } from 'vuex';

const authenticationModule: AuthenticationModule = getModule(
  AuthenticationModule,
  store
);

@Component({
  components: {
    LoadingComponent
  },
  computed: {
    ...mapState('authentication', ['showLoading'])
  }
})
export default class ChangeEmailView extends mixins(ChangeEmailMixin) {
  public showLoading: boolean;

  public created() {
    this.confirmEmail().then(() => {
      this.validateRequest();
    });
  }

  /**
   * Logic specific to /confirm-email page.
   */
  private async validateRequest(): Promise<void> {
    if (authenticationModule.confirmChangeEmailSuccess) {
      this.$toasted.success(
        'Success! Please use your updated email address to login.',
        {
          duration: 4000,
          onComplete: async () => {
            if (authenticationModule.confirmChangeEmailIsCustomer) {
              await this.$router.replace({ path: routePath.base });
            } else {
              await this.$router.replace({ name: routeName.login });
            }
          }
        }
      );
    } else {
      for (
        let i = 0;
        i !== (authenticationModule.errorMessages?.length ?? 0);
        i++
      ) {
        this.$toasted.error(
          authenticationModule.errorMessages?.[i] ?? 'An error occurred!',
          {
            duration: Infinity
          }
        );
      }
    }
  }
}
